const getState = ({ getStore, setStore, getActions }) => {
  return { 
    store: {
      isFetching: false,
      otro: true
    },
    actions: {
      setIsFetching: (state) => {
        setStore({ isFetching: state });
      }
    },
  };
};
export default getState;
